<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import ProductForm from "./components/ProductForm.vue"

defineProps<{
  product: {
    id: number
    company_id: number | ""
    name: string
    sku: string
    kind: string
    measurement_unit_id: number | ""
    cost_price_cents: string
    can_be_purchased: boolean
  }
  companies: Array<{ id: number; name: string }>
  kinds: Array<{ label: string; value: string }>
  measurement_units: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <ProductForm
      mode="edit"
      title="Produtos/ProductsEdit"
      subtitle="Atualize os dados do produto mantendo historico de SKU e custo atual."
      :product="product"
      :companies="companies"
      :kinds="kinds"
      :measurement-units="measurement_units"
      :errors="errors"
    />
  </AppShell>
</template>

